import React from 'react';
import { cn } from '@utils/cn';
import { highlightWordsFunc } from '../editor/Helpers';
import * as Opt from '../editor/Helpers';
import TextVariant, { getTextVariantUiProps } from '../editor/fields/TextVariant';

class Header extends React.Component {
    constructor() {
        super();
    }

    getSizeClass() {
        switch(this.props.type){
            case "h1":
                return "text-[49px] leading-[1.06] tracking-[-1.47px] md:text-[95px] md:leading-[1.01] md:tracking-[-2.85px]";
            case "h2":
                return "text-[39px] leading-[1.01] tracking-[-1.17px] md:text-[76px] md:leading-[1] md:tracking-[-2.28px]";
            case "h3":
                return "text-[31px] leading-[1.02] tracking-[-0.93px] md:text-[61px] md:leading-[1.04] md:tracking-[-1.83px]";
            case "h4":
                return "text-[25px] leading-[1.1] tracking-[-0.75px] md:text-[49px] md:leading-[1.05] md:tracking-[-1.47px]";
        }
        return "";
    }

    render() {
        const visibilityClass = `${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50' : this.props.visibility == "dt" ? 'hidden lg:block' : this.props.visibility == "mob" ? 'lg:hidden' : ''}`;
        const spacingClasses = Opt.CalculateSpacing(this.props.spacing);
        const { contentClasses, wrapperPaddingClasses } = Opt.splitTextSpacingClasses(spacingClasses);

        if (getTextVariantUiProps(this.props.textVariants, this.props.textVariant)) {
            return (
                <TextVariant
                    textVariants={this.props.textVariants}
                    textVariant={this.props.textVariant}
                    as={this.props.type}
                    className={cn(visibilityClass, 'w-full min-w-0 max-w-full', wrapperPaddingClasses)}
                    wrapperStyle={{ overflow: 'hidden', width: this.props.headerWidth }}
                    align={this.props.textAlign}
                    useQuillTypography={false}
                    innerClassName={cn('[overflow-wrap:anywhere]', contentClasses, this.props.color, this.props.textStyle)}
                    innerStyle={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
                >
                    {this.props.highlight.words?.length > 0
                        ? highlightWordsFunc(
                              this.props.text,
                              Array.from(this.props.highlight.words, (w) => w.word),
                              this.props.highlight.color,
                              this.props.highlight.backgroundColor,
                              this.props.highlight.rounded,
                              this.props.highlight.padding
                          )
                        : this.props.text}
                </TextVariant>
            );
        }

        const size = this.getSizeClass();
        
        return (
            <div className={cn('legacy-bootstrap', visibilityClass, 'w-full min-w-0 max-w-full', wrapperPaddingClasses)} style={{ width: this.props.headerWidth }}>
                {this.props.highlight.words?.length > 0 ? (
                    React.createElement(
                        this.props.type,
                        {
                            className: `font-nista-grotesk [overflow-wrap:anywhere] ${size} ${this.props.textAlign} ${this.props.color} ${contentClasses} ${Opt.CalculateFontSize(this.props.fontSizes)} ${this.props.textStyle}`,
                            style: { whiteSpace: "pre-wrap", overflowWrap: "anywhere" }
                        },
                        highlightWordsFunc(this.props.text, Array.from(this.props.highlight.words, (w) => w.word), this.props.highlight.color, this.props.highlight.backgroundColor, this.props.highlight.rounded, this.props.highlight.padding)
                    )
                ) : (
                    React.createElement(
                        this.props.type,
                        {
                            className: `font-nista-grotesk [overflow-wrap:anywhere] ${size} ${this.props.textAlign} ${this.props.color} ${contentClasses} ${Opt.CalculateFontSize(this.props.fontSizes)} ${this.props.textStyle}`,
                            style: { whiteSpace: "pre-wrap", overflowWrap: "anywhere" }
                        },
                        this.props.text
                    )
                )}

            </div>
        )

    }

}

Header.defaultProps = {
    visibility: "",
    type: 'h1',
    color: 'neutral-charcoal',
    text: 'Heading',
    textAlign: "text-start",
    spacing: [],
    highlight: { words: [], color: 'neutral-charcoal', backgroundColor: 'white', rounded: '', padding: 'p-1' },
    headerWidth: "100%",
    textStyle: "",
    fontSizes: [],
    fontSize: '',
    textVariant: '',
    textVariants: [],
}

Header.fields = {
    visibility: {
        type: "select",
        options: Opt.visibilityOptions
      },
    headerWidth: {
        type: "text",
    },
    text: {
        type: "textarea",
    },
    type: {
        type: "select",
        options: Opt.headerElements
    },
    color: {
        type: "select",
        options: Opt.colorVariables
    },
    textAlign: {
        type: "select",
        options: Opt.TextAlign
    },
    spacing: Opt.spacingOptions,
    highlight: Opt.highlightOptions,
    textStyle: {
        type: "select",
        options: Opt.TextStyles
    },
    fontSizes: Opt.fontSizeOptions,
    textVariants: Opt.textVariantOptions,
}

export default Header;